import { Tooltip as TooltipPrimitive } from '@base-ui/react/tooltip';
import { cn } from '@/shared/lib';
import type { TooltipContentProps } from '@/shared/ui/tooltip/types';
import { tooltipStyles } from '@/shared/ui/tooltip/styles';

/**
 * The tooltip text, anchored to its trigger.
 *
 * `role="tooltip"` is set explicitly: this text is the trigger's accessible
 * description, and the relationship has to be announced for the tooltip to be
 * useful at all.
 */
export function TooltipContent({
  className,
  children,
  side,
  sideOffset,
  ...props
}: TooltipContentProps) {
  return (
    <TooltipPrimitive.Portal>
      {/*
        THE Z-INDEX BELONGS ON THE POSITIONER, NOT ON THE POPUP.

        The Positioner is `position: absolute` with `will-change: transform`,
        which makes it a STACKING CONTEXT. A `z-index` on the Popup inside it is
        therefore scoped to that context and cannot lift the tooltip above
        anything outside it — the Popup's `z-50` was measured losing to a sticky
        table cell's `z-10`, so the tooltip rendered BEHIND the pinned column it
        was describing.

        Raising the Positioner lifts the whole portal layer, which is what the
        tooltip actually needs: it is portaled to `<body>`, so it competes with
        the page's own stacking contexts, and the sticky cells in a data table
        are the tallest thing it has to clear.
      */}
      <TooltipPrimitive.Positioner
        side={side}
        sideOffset={sideOffset}
        className={tooltipStyles.positioner}
      >
        <TooltipPrimitive.Popup
          className={cn(tooltipStyles.popup, className)}
          role="tooltip"
          {...props}
        >
          {children}
          <TooltipPrimitive.Arrow className={tooltipStyles.arrow} />
        </TooltipPrimitive.Popup>
      </TooltipPrimitive.Positioner>
    </TooltipPrimitive.Portal>
  );
}